/* eslint-disable eslint-comments/disable-enable-pair -- disabled */
/* eslint-disable default-param-last -- disabled default parameters */
import { fromJS } from 'immutable';

export const SET_AUTH_STATUS = 'modules/axp-manage-bookings-root/SET_AUTH_STATUS';

export const initialState = fromJS({
  authenticated: false,
  loaded: false,
});

export default function reducer(state = initialState, action) {
  switch (action?.type) {
    case SET_AUTH_STATUS:
      return state
        .set('authenticated', !!action?.authenticated)
        .set('loaded', true);
    default:
      return state;
  }
}

export function setAuthentication(authenticated = false) {
  return {
    type: SET_AUTH_STATUS,
    authenticated,
  };
}
